import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import LicenseDetailsPage from './pages/LicenseDetailsPage/LicenseDetailsPage'
import CommissionsDirectDepositPage from './pages/CommissionsDirectDepositPage/CommissionsDirectDepositPage'
import AgencyInformationPage from './pages/AgencyInformationPage/AgencyInformationPage'
import TaxInformationPage from './pages/TaxInformationPage/TaxInformationPage'
import ProducerStandards from './pages/ProducerStandards/ProducerStandards'
import EFTPaymentInfo from './pages/EFTPaymentInfo/EFTPaymentInfo'
import AgentConfirmationPage from './pages/Confirmation/AgentConfirmationPage.jsx'
import AgentRegistrationCompletePage from './pages/RegistrationComplete/AgentRegistrationCompletePage'

setComponentMapOverrides(
    {
        LicenseDetailsPage: { component: 'LicenseDetailsPage' },
        AgencyInformationPage: { component: 'AgencyInformationPage' },
        CommissionsDirectDepositPage: { component: 'CommissionsDirectDepositPage' },
        TaxInformationPage: { component: 'TaxInformationPage' },
        ProducerStandards: {component: 'ProducerStandards'},
        EFTPaymentInfo: {component: 'EFTPaymentInfo'},
        AgentConfirmationPage: {component: 'AgentConfirmationPage'},
        AgentRegistrationCompletePage: {component: 'AgentRegistrationCompletePage'}
    },
    {
        LicenseDetailsPage,
        AgencyInformationPage,
        CommissionsDirectDepositPage,
        TaxInformationPage,
        ProducerStandards,
        EFTPaymentInfo,
        AgentConfirmationPage,
        AgentRegistrationCompletePage
    }
    );

export { AgentRegistrationWizard } from './AgentRegistrationWizard'
export { default as AgentRegistrationWizardTemplate } from './templates/AgentRegistrationWizardTemplate.jsx';
export { default as ActivationPage } from './pages/Activation/ActivationPage'
export { default as UserActivationPage } from './pages/Activation/UserActivationPage'
